const API_URL =
  process.env.API_URL || 'https://getinked-w74fr6mhza-uc.a.run.app';
export default API_URL;
